import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'

import { AppSettingsContext } from '../../Contexts'
import { XyoWorldMapStyle } from '../../lib'
import { Property } from '../../Properties'

const MapStyleProperty: React.FC = () => {
  const { mapStyle, updateMapStyle } = useContext(AppSettingsContext)

  const onChange = (event: SelectChangeEvent<string>) => {
    updateMapStyle?.(event.target.value as XyoWorldMapStyle)
  }

  return (
    <Property tip="The style of the map used on this site" title="Map Style" value={mapStyle}>
      <Select onChange={onChange} value={mapStyle} variant="standard">
        <MenuItem value={XyoWorldMapStyle.Streets}>Streets</MenuItem>
        <MenuItem value={XyoWorldMapStyle.Outdoors}>Outdoors</MenuItem>
        <MenuItem value={XyoWorldMapStyle.Dark}>Dark</MenuItem>
        <MenuItem value={XyoWorldMapStyle.Light}>Light</MenuItem>
        <MenuItem value={XyoWorldMapStyle.Satellite}>Satellite</MenuItem>
        <MenuItem value={XyoWorldMapStyle.SatelliteStreets}>Satellite/Streets</MenuItem>
      </Select>
    </Property>
  )
}

export default MapStyleProperty
